<template>
    <div>
        <fullscreen-drawer
            v-if="featureFlags['live-site-responsive-design']"
            :visible="visible"
            @close="handleClose"
        >
            <loader v-if="isLoading" />
            <OnboardingStep
                v-else
                :title="getCurrent().title"
                :message="getCurrent().message"
                :image="getCurrent().image"
                :is-done="isDone"
                :current-step-id="currentStepId"
                :is-link-loading="isLinkLoading"
                @close="handleClose"
                @continue="handleContinue"
            />
        </fullscreen-drawer>

        <g-drawer
            v-else
            :visible="visible"
            :wrap-style="wrapStyle"
            height="100%"
            get-container="#app"
            placement="bottom"
            class="OnboardingStepsDrawer"
            @close="handleClose"
        >
            <loader v-if="isLoading" />
            <OnboardingStep
                v-else
                :title="getCurrent().title"
                :message="getCurrent().message"
                :image="getCurrent().image"
                :is-done="isDone"
                :current-step-id="currentStepId"
                :is-link-loading="isLinkLoading"
                @close="handleClose"
                @continue="handleContinue"
            />
        </g-drawer>
    </div>
</template>

<script>
    import { ref, toRefs, reactive, computed, watch, onMounted } from 'vue-demi';
    import {
        STEP_PROPOSAL_ID,
        STEP_TAX_INFO_ID,
        STEP_PAYOUT_METHOD_ID,
        ONBOARDING_STEPS_PAGES
    } from '../../../../../app-v2/constants/payouts';
    import useRouter from '../../../../composables/use-router';
    import useOnboarding from '../../../../composables/use-onboarding';
    import OnboardingStep from './OnboardingStep.vue';
    import FullscreenDrawer from '../../../../../app-v2/components/library/FullscreenDrawer.vue';
    import { useFeatureFlagsStore } from '../../../../../stores';

    export default {
        components: {
            FullscreenDrawer,
            OnboardingStep
        },

        name: 'OnboardingStepsDrawer',

        props: {
            visible: {
                type: Boolean,
                default: false
            },
            isLoading: {
                type: Boolean,
                default: false
            },
            isLinkLoading: {
                type: Boolean,
                default: false
            },
            step: {
                type: Number,
                default: undefined
            }
        },

        setup(props, context) {
            const featureFlags = useFeatureFlagsStore().data;

            const router = useRouter().get();
            const wrapStyle = reactive({
                position: 'absolute'
            });
            const currentStepId = ref(0);

            const isDone = computed(() => currentStepId.value + 1 >= ONBOARDING_STEPS_PAGES.length);

            const { step, isLoading } = toRefs(props);
            watch([step, isLoading], () => {
                determineStep();
            });

            const getCurrent = () => {
                return ONBOARDING_STEPS_PAGES[currentStepId.value];
            };

            const setCurrent = (id) => {
                currentStepId.value = id;
                return ONBOARDING_STEPS_PAGES[id];
            };

            const handleClose = () => {
                context.emit('close');
            };

            const handleContinue = () => {
                const current = getCurrent();

                if (!current) {
                    return;
                }

                if (current.id === STEP_PROPOSAL_ID) {
                    redirectToSponsorships();
                } else if (current.id === STEP_TAX_INFO_ID) {
                    redirectToStripeConnect();
                } else if (current.id === STEP_PAYOUT_METHOD_ID) {
                    handleClose();
                    context.emit('open-add-payout-method-drawer');
                }
            };

            const determineStep = () => {
                if (step.value !== undefined) {
                    setCurrent(step.value);

                }
            };

            const { hasStarted: hasStartedOnboarding } = useOnboarding();

            const redirectToStripeConnect = async () => {
                if (!hasStartedOnboarding()) {
                    handleClose();
                    context.emit('open-country-selection');
                    return;
                }

                context.emit('redirect-to-stripe-connect');
            };

            const redirectToSponsorships = () => {
                router.push({ name: 'sponsorships' });
            };

            onMounted(() => {
                determineStep();
            });

            return {
                wrapStyle,
                currentStepId,
                isDone,
                handleClose,
                handleContinue,
                getCurrent,
                featureFlags
            };
        }
    };
</script>
